import type { StorePrice } from '../../platform/purchases';
import { PIXEL_FONT_CHARS } from './pixelGlyphs';

/** Non-breaking, narrow non-breaking and thin spaces (stores put them in prices). */
const ODD_SPACES = new RegExp(`[${String.fromCharCode(0xa0, 0x202f, 0x2009)}]`, 'g');

/**
 * A store price in the pixel font: the store's own string ("$2.99", "2,99 €") where the font has
 * every character, else the same amount with its currency code ("4400 KRW"), never a price with
 * its sign dropped. Odd spaces become plain ones.
 */
export function pixelPrice(price: Readonly<StorePrice>): string {
  const text = price.text.replace(ODD_SPACES, ' ').trim();
  if ([...text].every((c) => PIXEL_FONT_CHARS.includes(c))) return text;
  const amount = Number.isInteger(price.amount) ? String(price.amount) : price.amount.toFixed(2);
  return `${amount} ${price.currency}`;
}
